import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { AnalisisDemandaService } from 'src/app/services/analisis-demanda.service';
import { DocumentoNoTributarioService } from 'src/app/services/documento-no-tributario.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConfirmarNotaVentaModalResultadoComponent } from './modal-resultado/modal-resultado.component';
import { ConfirmarNotaVentaModalVerPedidoComponent } from './modal-ver-pedido/modal-ver-pedido.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import * as _ from 'lodash';
import { ComunaService } from 'src/app/services/comuna.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ModalVerErroresComponent } from '../../shared/modal-ver-errores/modal-ver-errores.component';
import { SignalRMessageService } from 'src/app/services/SignalRMessage.service';
import { DataCAF } from 'src/app/shared/object/data_caf.model';
import { DataCafService } from 'src/app/services/data-caf.service';
import { ENVIRONMENT_FUNCTIONS } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-confirmar-nota-venta',
  templateUrl: './confirmar-nota-venta.component.html',
  styleUrls: ['./confirmar-nota-venta.component.scss'],
  providers: [SecurityService],
})
export class ConfirmarNotaVentaComponent implements OnInit, OnDestroy {
  // Modales
  @ViewChild(ConfirmarNotaVentaModalVerPedidoComponent, { static: true }) modalVerPedidos: ConfirmarNotaVentaModalVerPedidoComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  // @ViewChild(ConfirmarNotaVentaModalVerAdvertenciaComponent, { static: true }) modalVerResultado: ConfirmarNotaVentaModalVerAdvertenciaComponent
  @ViewChild(ConfirmarNotaVentaModalResultadoComponent, { static: true }) modalVerResultado: ConfirmarNotaVentaModalResultadoComponent;
  @ViewChild(ModalVerErroresComponent, { static: true }) modalVerErrores: ModalVerErroresComponent;

  // Forms
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private rutUsuario: number;
  loading: boolean = false;
  listaMovimientos: Array<any> = null;

  optionsComunas: Array<any> = [];
  optionsVendedor: Array<any> = [];

  paginationContext: PaginationContext = new PaginationContext();
  headerData: any;
  isProcessed: boolean = false;
  processing: boolean = false;
  sumMontoNeto: number = null;
  sumMontoBruto: number = null;

  // Utils
  private log: any;
  resumen_listaMovimientosAll: any;
  resumen_totales: { monto_total_bruto: number; monto_total_neto: number };

  //Variables
  checkAll: boolean = false;
  SelectDoc: Array<any> = [];
  listaMovimientosAll: Array<any> = null;
  docSeleccionado: number = 0;
  codigos_dte: number[];

  // COUNT PARA LAS FACTURAS REALIZADAS
  contadorFacturas: number = 0;

  private readonly destroy$ = new Subject<void>();
  private isDestroyed = false;

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    private analisisDemandaService: AnalisisDemandaService,
    private documentoNoTributarioService: DocumentoNoTributarioService,
    private rutService: RutService,
    private fb: FormBuilder,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
    private comunasService: ComunaService,
    private vendedorService: VendedorService,
    private signalRMessageService: SignalRMessageService,
    private dataCafService: DataCafService
  ) {
    this.log = this.clog.log('CONFIRMAR-NOTAS-DE-VENTA');
    // Seteamos los codigos DTE
    this.codigos_dte = [33];
    // Seteamos el valor del codigo DTE
    this.dataCafService.setDataCodigoDTE(33);
  }

  ngOnInit() {
    this.codigos_dte = [33];
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());

    this.paginationContext.RecordsByPage = 10;
    this.loadComunas();
    this.loadVendedores();
    this.createForm();
    this.loadDoctosProcesadosAnalisis();
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    this.processing = false;
    this.loading = false;
  }

  private canUpdateView(): boolean {
    return !this.isDestroyed;
  }

  private obtenerFoliosSeleccionadosValidos(selected: any[]): number[] {
    const folios = (selected || [])
      .map((x) => Number(x && x.folio))
      .filter((folio) => Number.isFinite(folio) && folio > 0);

    // Evitar folios duplicados en el request.
    return Array.from(new Set(folios));
  }

  private createForm() {
    const now = this.datesService.CurrentDateToShortTimeString();
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      fechaEmision: [now, [Validators.required]],
      vendedor: [],
      comuna: [],
    });
  }

  loadDoctosProcesadosAnalisis() {
    this.loadCabecera();
    // this.buscar(1)
  }

  private loadComunas() {
    // Tipos documentos
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalCodigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
      soloAprobadosAnalisis: true,
    };

    this.comunasService.obtenerComunayVendedorConfirmacionNventa(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsComunas = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
    });
  }

  private loadVendedores() {
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalCodigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
      soloAprobadosAnalisis: true,
    };

    this.vendedorService.obtenerVendedoresConfirmacionNventa(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({ value: vendedor.codigo, label: vendedor.nombre, ...vendedor }));
    });
  }

  loadCabecera() {
    if (!this.canUpdateView()) return;
    this.enableFechaEmision();

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    // TODO: REMOVE THIS DUMMY DATA
    // this.headerData = {
    //   "empresa_rut": 76150970.0,
    //   "sucursal_codigo": 1.0,
    //   "fecha_analisis": "2022-03-01T03:57:10Z",
    //   "fecha_inicio_busqueda": "2021-03-01T03:00:00Z",
    //   "fecha_termino_busqueda": "2022-03-01T03:00:00Z",
    //   "nombreBodega": "Bodega 1",
    //   "nroPedidos": 1.0
    // }

    this.analisisDemandaService.obtenerDatosGeneralesAnalisis(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      this.headerData = respuesta;
    });
  }

  buscar(pageNumber: number) {
    if (!this.canUpdateView()) return;
    const { comuna, vendedor } = this.formHeader.value;

    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return
    this.calculateTotalesResumen();

    this.paginationContext.CurrentPage = pageNumber;

    this.listaMovimientos = [];
    this.listaMovimientosAll = null;

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalCodigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
      soloAprobadosAnalisis: true,
      comunaSel: comuna,
      vendedorSel: vendedor,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    // this.loading = true
    // setTimeout(() => {
    //   // if (mensajes && mensajes.length > 0) {
    //   //   this.messageRendererService.showInfoMessages(mensajes)
    //   //   this.messageRendererService.showErrors(mensajes)
    //   //   this.loading = false
    //   //   return
    //   // }

    //   const respuesta = {
    //     "paginaActual": 1,
    //     "cantidadRegistrosPorPagina": 10,
    //     "totalPaginas": 1,
    //     "totalRegistros": 1,
    //     "registros": [
    //       {
    //         "direccion_codigo": 107.0,
    //         "nombrecliente": "PANIFICADORA LOS RODRIGUEZ SPA",
    //         "direccion_cliente_rut": 77251902.0,
    //         "sucursal_codigo": 1.0,
    //         "rut_empresa": 76150970.0,
    //         "folio": 130.0,
    //         "tipo_dte_codigo": 2.0,
    //         "condicion_pago_codigo": 105.0,
    //         "estado_documento_codigo": 4.0,
    //         "vendedor_codigo": 2000,
    //         "rut_usuario_registro": 16548027.0,
    //         "fecha_emision": "2022-02-28T23:41:18.232688Z",
    //         "observacion_1": "",
    //         "observacion_2": "",
    //         "fecha_registro": "2022-02-28T23:41:18.490214Z",
    //         "folio_transformado": 0.0,
    //         "tipo_dte_codigo_transformado": 0.0,
    //         "totalBruto": 22798.02,
    //         "pedido_codigo": 783.0,
    //       }
    //     ],
    //   }

    //   const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    //   this.paginationContext.RecordsCount = totalRegistros
    //   this.paginationContext.CurrentPage = paginaActual
    //   this.paginationContext.PagesCount = totalPaginas
    //   this.listaMovimientos = registros

    //   this.listaMovimientos.map(mov => {
    //     mov.rutFormato = this.rutService.AgregarDV(mov.direccion_cliente_rut)
    //   })

    //   this.loading = false
    // }, 100)

    this.loading = true;
    this.documentoNoTributarioService.obtenerDoctosProcesadosAnalisis(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        this.disableFechaEmision();
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;

      this.listaMovimientosAll = registros;
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = pageNumber;

      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {};
        mov.additionalInfo.index = index;
        mov.rutFormato = this.rutService.AgregarDV(mov.direccion_cliente_rut);
        mov.checked = false;
      });

      // this.paginationContext.RecordsCount = totalRegistros
      // this.paginationContext.CurrentPage = paginaActual
      // this.paginationContext.PagesCount = totalPaginas
      // this.listaMovimientos = registros

      // this.listaMovimientos.map(mov => {
      //   mov.rutFormato = this.rutService.AgregarDV(mov.direccion_cliente_rut);
      //   mov.checked = false;
      // })

      // const sumallNeto = this.listaMovimientos.map(item => item.total_neto ).reduce((prev, curr) => prev + curr, 0);
      // const sumallBruto = this.listaMovimientos.map(item => item.totalBruto ).reduce((prev, curr) => prev + curr, 0);

      // this.sumMontoNeto = sumallNeto
      // this.sumMontoBruto = sumallBruto

      this.showPage(this.paginationContext.CurrentPage);

      // * AL SELECCIONAR VENDEDOR O COMUNA SE REALIZA LA BUSQUEDA Y SE PRESIONA EL CHECK ALL
      if (vendedor != null && vendedor.length > 0) {
        this.checkAllChange({ checked: true });
      } else {
        if (comuna != null && comuna.length > 0) {
          this.checkAllChange({ checked: true });
        } else {
          this.checkAll = false;
        }
      }

      //* FIN

      // if(comuna.length > 0){
      //   this.checkAllChange({ checked: true });
      // }

      this.loading = false;

      if (this.listaMovimientos.length == 0) this.disableFechaEmision();
    });
  }

  enableFechaEmision() {
    if (!this.canUpdateView()) return;
    this.formHeader.get('fechaEmision').enable();
  }

  disableFechaEmision() {
    if (!this.canUpdateView()) return;
    this.formHeader.get('fechaEmision').disable();
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
    // this.buscar(context.RequestedPage)
  }

  loadAndShowVerPedidos(mov) {
    this.modalVerPedidos.loadAndShow(mov);
  }

  showModalConfirm() {
    if (!this.canUpdateView()) return;
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (this.formHeader.invalid) {
      this.toastService.warning('Ingrese fecha emisión');
      return;
    }
    const selected = _.cloneDeep(this.listaMovimientosAll).filter((mov) => mov.checked);
    if (selected.length === 0) {
      this.toastService.warning('No se ha seleccionado un documento');
      return;
    }
    const listaSeleccionados = this.obtenerFoliosSeleccionadosValidos(selected);
    if (listaSeleccionados.length !== selected.length) {
      this.toastService.warning('Se omitieron notas de venta con folio inválido (0 o vacío).');
    }
    if (listaSeleccionados.length === 0) {
      this.toastService.warning('No existen folios válidos para procesar.');
      return;
    }
    this.documentoNoTributarioService.validarPrecioCeroNotasVenta(
      { rutEmpresa: this.rutEmpresa, sucursalCodigo: this.sucursalCodigo, folios: listaSeleccionados },
      ({ mensajes, respuesta }) => {
        if (!this.canUpdateView()) return;
        if (mensajes && mensajes.some((m) => m.tipo === 'ERROR')) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        if (respuesta && respuesta.length > 0) {
          this.generaFacturasMasivasConRefresh();
          return;
        }
        this.modalConfirm.show(() => {
          this.generaFacturasMasivas();
        });
      }
    );
  }

  /** Llama a generaFacturasMasivas y refresca la lista al terminar (para NVs revertidas por precio 0). */
  generaFacturasMasivasConRefresh() {
    if (!this.canUpdateView()) return;
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (this.formHeader.invalid) return;
    const selected = _.cloneDeep(this.listaMovimientosAll).filter((mov) => mov.checked);
    if (selected.length === 0) return this.toastService.warning('No se ha seleccionado un documento');
    const listaSeleccionados = this.obtenerFoliosSeleccionadosValidos(selected);
    if (listaSeleccionados.length !== selected.length) {
      this.toastService.warning('Se omitieron notas de venta con folio inválido (0 o vacío).');
    }
    if (listaSeleccionados.length === 0) return this.toastService.warning('No existen folios válidos para procesar.');
    const fechaEmision = this.formHeader.get('fechaEmision').value;
    const inputParams = {
      fechaEmision,
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      rutUsuario: this.rutUsuario,
      folios: listaSeleccionados,
    };
    this.processing = true;
    this.documentoNoTributarioService.generaFacturasMasivas(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      if (mensajes && mensajes.length > 0) {
        // Evitar toast redundante cuando el warning corresponde a "precio 0".
        // El detalle se mostrará vía el modal de errores/información.
        const mensajesParaToast = mensajes.filter(
          (m) =>
            !(
              m &&
              m.tipo === 'WARNING' &&
              typeof m.texto === 'string' &&
              m.texto.toLowerCase().includes('precio 0')
            )
        );
        if (mensajesParaToast.length > 0) {
          this.messageRendererService.showWarningMessages(mensajesParaToast);
        }
        this.modalVerErrores.loadAndShow(mensajes);
        if (mensajes.some((m) => m.tipo === 'ERROR')) {
          this.processing = false;
          return;
        }
      }
      this.processing = false;
      this.loadCabecera();
      this.loadComunas();
      this.loadVendedores();
      this.buscar(1);
      if (respuesta && Array.isArray(respuesta) && respuesta.length > 0) {
        this.showVerResultado(respuesta);
        this.disableFechaEmision();
        this.isProcessed = true;
        const numDocumentos = this.contarDocumentosTributariosGenerados(respuesta);
        this.sumarContadorFacturas(numDocumentos);
      }
    });
  }

  showModalConfirmNotificacion() {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (this.formHeader.invalid) {
      this.toastService.warning('Ingrese fecha emisión');
      return;
    }
    this.modalConfirm.show(() => {
      this.generaFacturasMasivasSendMessage();
    });
  }

  generaFacturasMasivasSendMessage() {
    if (!this.canUpdateView()) return;
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (this.formHeader.invalid) {
      return;
    }

    // * LISTA DE NOTAS DE VENTA SELECCIONADOS
    const selected = _.cloneDeep(this.listaMovimientosAll).filter((mov) => mov.checked);

    if (selected.length == 0) {
      return this.toastService.warning('No se ha seleccionado un documento');
    }

    const listaSeleccionados = this.obtenerFoliosSeleccionadosValidos(selected);
    if (listaSeleccionados.length !== selected.length) {
      this.toastService.warning('Se omitieron notas de venta con folio inválido (0 o vacío).');
    }
    if (listaSeleccionados.length === 0) {
      return this.toastService.warning('No existen folios válidos para procesar');
    }
    const fechaEmision = this.formHeader.get('fechaEmision').value;
    const inputParams = {
      fechaEmision,
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      rutUsuario: this.rutUsuario,
      folios: listaSeleccionados,
    };

    const inputParamsNotificacion = {
      entidad: {
        tipo_notificacion_codigo: 5,
        categoria_modulo_codigo: 2,
        fecha_emision: fechaEmision,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        rut_usuario: this.rutUsuario,
        folios: listaSeleccionados,
        environment_functions: ENVIRONMENT_FUNCTIONS,
      },
    };
    this.analisisDemandaService.cambiarEstadoProcesoAnalisis(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      if (mensajes && mensajes.length > 0) {
        this.processing = false;
        // this.messageRendererService.showInfoMessages(mensajes)
        this.modalVerErrores.loadAndShow(mensajes);
        return;
      }

      this.toastService.success('Operación realizada');

      this.isProcessed = true;
      this.processing = false;


      //this.showVerResultado(respuesta);
      this.disableFechaEmision();
      this.loadCabecera();

      //* RECARGAR FILTRO DE COMUNAS Y VENDEDORES
      this.loadComunas();
      this.loadVendedores();
      this.buscar(1);
      this.sendMessage(inputParamsNotificacion);
    });
  }

  sendMessage(inputParams: any) {
    this.signalRMessageService.send(inputParams).pipe(takeUntil(this.destroy$)).subscribe(
      () => {
        if (!this.canUpdateView()) return;
        this.processing = false;
        //console.log('Mensaje enviado con éxito');
      },
      (error) => {
        if (!this.canUpdateView()) return;
        this.processing = false;
        console.error('Error al enviar el mensaje:', error);
      }
    );
  }

  generaFacturasMasivas() {
    if (!this.canUpdateView()) return;
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (this.formHeader.invalid) {
      return;
    }

    // * LISTA DE NOTAS DE VENTA SELECCIONADOS
    const selected = _.cloneDeep(this.listaMovimientosAll).filter((mov) => mov.checked);

    if (selected.length == 0) {
      return this.toastService.warning('No se ha seleccionado un documento');
    }

    const listaSeleccionados = this.obtenerFoliosSeleccionadosValidos(selected);
    if (listaSeleccionados.length !== selected.length) {
      this.toastService.warning('Se omitieron notas de venta con folio inválido (0 o vacío).');
    }
    if (listaSeleccionados.length === 0) {
      return this.toastService.warning('No existen folios válidos para procesar');
    }

    const fechaEmision = this.formHeader.get('fechaEmision').value;

    const inputParams = {
      fechaEmision,
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      rutUsuario: this.rutUsuario,
      folios: listaSeleccionados,
    };

    this.processing = true;

    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoNoTributarioService.generaFacturasMasivas(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      if (mensajes && mensajes.length > 0) {
        this.modalVerErrores.loadAndShow(mensajes);
        if (mensajes.some((m) => m.tipo === 'ERROR')) {
          this.processing = false;
          return;
        }
      }

      // this.toastService.success('Operación realizada')

      console.log({ respuesta });

      this.isProcessed = true;
      this.processing = false;
      this.showVerResultado(respuesta);
      this.disableFechaEmision();
      this.loadCabecera();

      //* RECARGAR FILTRO DE COMUNAS Y VENDEDORES
      this.loadComunas();
      this.loadVendedores();
      if (Array.isArray(respuesta)) {
        const numDocumentos = this.contarDocumentosTributariosGenerados(respuesta);
        this.sumarContadorFacturas(numDocumentos);
      }
    });
  }
  contarDocumentosTributariosGenerados(respuesta: any[]): number {
    const folios: number[] = [];
    respuesta.forEach((item) => {
      const folio = item.cabecera.folio;
      if (!folios.some((x) => x === folio)) folios.push(folio);
    });
    return folios.length;
  }
  sumarContadorFacturas(numDocumentos: number) {
    this.contadorFacturas += numDocumentos;
  }

  checkAllChange({ checked }) {
    //SELECCIONAR TODO
    this.checkAll = checked;

    // SELECCIONAR TODAS LAS NOTAS DE VENTA EN TOTAL
    this.listaMovimientosAll.forEach((detalle) => {
      detalle.checked = checked;
    });

    //SELECCIONAR LA LISTA DE LA PAGINA ACTUAL
    this.listaMovimientos.forEach((detalle) => {
      detalle.checked = checked;
    });

    //ELEMENTOS SELECCIONADOS
    this.docSeleccionado = 0;
    this.cantidadSeleccionada();

    //ARRAY DE ELEMENTOS SELECCIONADOS
    this.SelectDoc = _.cloneDeep(this.listaMovimientos).filter((x) => x.checked === true);

    this.SelectDoc.forEach((doc) => {
      delete doc.checked;
      delete doc.comuna;
      delete doc.condicion_pago_codigo;
      delete doc.direccion_cliente_rut;
      delete doc.direccion_codigo;
      delete doc.estado_documento_codigo;
      delete doc.fecha_emision;
      delete doc.fecha_registro;
      delete doc.folio_transformado;
      delete doc.nombrecliente;
      delete doc.observacion_1;
      delete doc.observacion_2;
      delete doc.pedido_codigo;
      delete doc.rutFormato;
      delete doc.rut_empresa;
      delete doc.rut_usuario_registro;
      delete doc.sucursal_codigo;
      delete doc.tipo_dte_codigo;
      delete doc.tipo_dte_codigo_transformado;
      delete doc.total;
      delete doc.totalBruto;
      delete doc.total_neto;
      delete doc.vendedor_codigo;
      delete doc.vendedor_nombre;
      delete doc.__typename;
    });
  }

  //SELECCION INDIVIDUAL
  checkDetalle({ folio }, { checked }) {
    const selectedMain: any = this.listaMovimientosAll.filter((p) => p.folio === folio)[0];
    selectedMain.checked = !checked;

    this.listaMovimientos.map((detalle) => {
      if (detalle.folio === folio) {
        detalle.checked = checked;
      }
    });

    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.listaMovimientos.filter((detalle: any) => !detalle.checked).length;
    this.checkAll = totalUnselected === 0;

    //ARRAY DE ELEMENTOS SELECCIONADOS
    this.SelectDoc = _.cloneDeep(this.listaMovimientos).filter((x) => x.checked === true);

    //ELEMENTOS SELECCIONADOS
    this.docSeleccionado = 0;
    this.cantidadSeleccionada();

    this.SelectDoc.forEach((doc) => {
      delete doc.checked;
      delete doc.comuna;
      delete doc.condicion_pago_codigo;
      delete doc.direccion_cliente_rut;
      delete doc.direccion_codigo;
      delete doc.estado_documento_codigo;
      delete doc.fecha_emision;
      delete doc.fecha_registro;
      delete doc.folio_transformado;
      delete doc.nombrecliente;
      delete doc.observacion_1;
      delete doc.observacion_2;
      delete doc.pedido_codigo;
      delete doc.rutFormato;
      delete doc.rut_empresa;
      delete doc.rut_usuario_registro;
      delete doc.sucursal_codigo;
      delete doc.tipo_dte_codigo;
      delete doc.tipo_dte_codigo_transformado;
      delete doc.total;
      delete doc.totalBruto;
      delete doc.total_neto;
      delete doc.vendedor_codigo;
      delete doc.vendedor_nombre;
      delete doc.__typename;
    });
  }

  cantidadSeleccionada() {
    let cont = 1;
    this.listaMovimientosAll.forEach((mov) => {
      if (mov.checked === true) {
        this.docSeleccionado = cont;
        cont++;
      }
    });
  }

  calculateTotalesResumen() {
    if (!this.canUpdateView()) return;
    const { comuna, vendedor } = this.formHeader.value;

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalCodigo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
      soloAprobadosAnalisis: true,
      comunaSel: comuna,
      vendedorSel: vendedor,
    };

    this.documentoNoTributarioService.obtenerDoctosProcesadosAnalisis(inputParams, ({ mensajes, respuesta }) => {
      if (!this.canUpdateView()) return;
      const resolve = respuesta;

      this.resumen_listaMovimientosAll = resolve.registros;

      this.resumen_totales = {
        monto_total_bruto: _.sumBy(this.resumen_listaMovimientosAll, 'totalBruto'),
        monto_total_neto: _.sumBy(this.resumen_listaMovimientosAll, 'total_neto'),
      };
      this.sumMontoBruto = this.resumen_totales.monto_total_bruto;
      this.sumMontoNeto = this.resumen_totales.monto_total_neto;
    });
  }

  showVerResultado(data: any[]) {
    this.modalVerResultado.loadAndShow(data);
  }

  UpdateFiltro() {
    this.buscar(1);
  }

  cleanup() {
    this.loading = false;
    this.listaMovimientos = null;
    this.paginationContext = new PaginationContext();
    this.headerData = null;
  }

}
